const timeFormats = [
  {
    value: 'AM_PM',
    label: 'AM/PM'
  },
  {
    value: 'mil',
    label: 'Military Time'
  }
]
export default timeFormats



// WEBPACK FOOTER //
// ./src/constants/Timeformats.ts